<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar
              icon="mdi-shield-check"
            >{{ $t("dashboardCardSuperAdminUserRights") }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <v-form ref="form" v-model="valid">
              <v-card
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  <span class="headline">
                    {{
                    $t("settingsUserRightsisSuperAdminCardTitle")
                    }}
                  </span>
                </v-card-title>

                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.email"
                        :label="$t('lmFrmEmail')"
                        :rules="[validateRequired(), validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-switch
                        v-show="
                          $store.state.storeClient.client.modules
                            .moduleModerator.active
                        "
                        class="ma-0 pa-0"
                        v-model="editedItem.isModerator"
                        :label="$t('settingsUserRightsisModerator')"
                        dense
                      ></v-switch>
                      <v-switch
                        class="ma-0 pa-0"
                        v-model="editedItem.isAdmin"
                        :label="$t('settingsUserRightsisAdmin')"
                        dense
                      ></v-switch>
                      <v-switch
                        class="ma-0 pa-0"
                        v-model="editedItem.isSuperAdmin"
                        :label="$t('settingsUserRightsisSuperAdmin')"
                        dense
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
          <!-- GUMB SHRANI -->
          <simple-navigation-button
            right
            :title="$t('addEditFormSaveButton')"
            icon="mdi-content-save"
            @clicked="setUserRights"
          ></simple-navigation-button>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
          >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

export default {
  name: "settingsUserRights",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      valid: true,
      editedItem: {
        id: "",
        email: "",
        isModerator: false,
        isAdmin: true,
        isSuperAdmin: false,
        isSuperStoreAdmin: false,
        client: this.$store.state.storeClient.client.basicSettings.name
      }
    };
  },
  methods: {
    async setUserRights() {
      try {
        let result = await this.$store.dispatch("setUserRights", {
          email: this.editedItem.email,
          client: this.$store.state.storeClient.client.basicSettings.name,
          isModerator: this.editedItem.isModerator,
          isAdmin: this.editedItem.isAdmin,
          isSuperAdmin: this.editedItem.isSuperAdmin,
          isSuperStoreAdmin: false
        });
        if (result) {
          this.$store.commit({
            type: "showSnackbar",
            color: "success",
            message: this.$t("msgSuccessEdit")
          });
        } else {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: this.$t("settingsUserRightsisSuperAdminMsgNoEmail")
          });
        }
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error
        });
      }
    }
  }
};
</script>
